import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';

const EditBeforePublication = () => {
  const { id } = useParams();
  const history = useHistory();
  const [publication, setPublication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublication = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/${id}`);
        setPublication(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching publication:', err);
        setLoading(false);
      }
    };

    fetchPublication();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPublication((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const removeCitation = (index) => {
    const newCitations = [...publication.citations];
    newCitations.splice(index, 1); // Remove the citation at the specified index
    setPublication((prev) => ({ ...prev, citations: newCitations }));
  };
  

  const handleCitationsChange = (index, value) => {
    const newCitations = [...publication.citations];
    newCitations[index] = value;
    setPublication((prev) => ({ ...prev, citations: newCitations }));
  };

  const addCitation = () => {
    setPublication((prev) => ({ ...prev, citations: [...prev.citations, ''] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/beforepublications/edit/${id}`, publication);
      alert('Publication updated successfully.');
      history.push('/my-beforepublications');
    } catch (err) {
      console.error('Error updating publication:', err);
      alert('Update failed.');
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!publication) return <p>No publication found.</p>;

  if (publication.status !== '0') {
    return <p className="text-danger text-center mt-4">You can only edit Not Approved publications.</p>;
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-primary text-center">Edit Before Publication</h3>
      <form onSubmit={handleSubmit} className="card p-4 shadow">

        <div className="mb-3">
          <label className="form-label">Paper Title</label>
          <input
            type="text"
            className="form-control"
            name="paperTitle"
            value={publication.paperTitle}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Journal Name</label>
          <input
            type="text"
            className="form-control"
            name="journalName"
            value={publication.journalName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
  <div className="d-flex justify-content-between align-items-center mb-2">
    <label className="form-label mb-0">Citation References</label>
    <button type="button" className="btn btn-sm btn-secondary" onClick={addCitation}>
      Add Citation
    </button>
  </div>

  {publication.citations.map((cite, index) => (
    <div className="d-flex mb-2" key={index}>
      <input
        type="text"
        className="form-control me-2"
        value={cite}
        onChange={(e) => handleCitationsChange(index, e.target.value)}
        required
      />
      <button
        type="button"
        className="btn btn-sm btn-danger"
        onClick={() => removeCitation(index)}
      >
        Remove
      </button>
    </div>
  ))}
</div>



        <button type="submit" className="btn btn-primary">Update</button>
      </form>
    </div>
  );
};

export default EditBeforePublication;
